import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_DMODELS = "magazineheadings";
const BASE_URL = "/api/magazineheadings";

const MagazineHeadingHeadingsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const MAGAZINE_HEADING_EMPTY = {
    title: "",
    description: "",
    date: "",
    timeMagazines: []
};

export function useMagazineHeadingHeadings() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...MagazineHeadingHeadingsQueryConfig
    });
    return {...result, magazineHeadings: result.data};
}


export function useMagazineHeadingHeading(id) {

    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...MagazineHeadingHeadingsQueryConfig
    });
    return {...result, magazineHeading: result.data};
}

export function useMagazineHeadingsMutations() {
    async function createFunction(magazineHeading) {
        if (!magazineHeading) return;
        return await fetchPOST(BASE_URL, magazineHeading, false);
    }

    async function editFunction(magazineHeading) {
        if (!magazineHeading) return;
        return await fetchPUT(`${BASE_URL}/${magazineHeading.id}`, magazineHeading);
    }

    async function editMagazines(magazineHeading) {
        if (!magazineHeading) return;
        console.log({timeMagazineIds: magazineHeading.timeMagazineIds})
        return await fetchPUT(`${BASE_URL}/${magazineHeading.id}/magazines`, magazineHeading.timeMagazineIds);
    }

    async function deleteFunction(magazineHeading) {
        return await fetchDELETE(`${BASE_URL}/${magazineHeading.id}`)
    }

    return {
        createMagazineHeading: useMyMutation(createFunction, REACT_QUERY_ID_DMODELS, magazineHeading => `MagazineHeading ${magazineHeading.title} created`),
        editMagazineHeading: useMyMutation(editFunction, REACT_QUERY_ID_DMODELS, magazineHeading => `MagazineHeading ${magazineHeading.title} modified`),
        editMagazines: useMyMutation(editMagazines, REACT_QUERY_ID_DMODELS, magazineHeading => `MagazineHeading ${magazineHeading.title} modified`),
        deleteMagazineHeading: useMyMutation(deleteFunction, REACT_QUERY_ID_DMODELS, magazineHeading => `MagazineHeading ${magazineHeading.title} deleted.`)
    };

}